import React, { useState } from 'react';
export function Footer() {
  const [email, setEmail] = useState('');
  const handleSubmit = () => {
    // Handle newsletter signup here
    console.log('Newsletter signup:', email);
    // You can integrate with Klaviyo, Mailchimp, etc.
  };
  return <footer className="bg-[#2C2416] text-[#FAF7F2] py-20 px-6 md:px-12 lg:px-18 text-center" data-id="element-65">
      <div className="max-w-[1400px] mx-auto" data-id="element-66">
        {/* Logo */}
        <div className="text-[28px] font-light tracking-[-0.5px] mb-8 font-['Inter']" data-id="element-67">
          MODERN COMMERCE
        </div>
        {/* Newsletter Section */}

        {/* Navigation Links */}
        <nav className="flex flex-wrap justify-center gap-5 md:gap-10 mb-8" data-id="element-68">
          <a href="/designandbuild" className="text-[#FAF7F2] hover:text-[#D4A574] transition-colors font-['Inter']" data-id="element-69">
            Design & Build
          </a>
          <a href="/shopify-design-development" className="text-[#FAF7F2] hover:text-[#D4A574] transition-colors font-['Inter']" data-id="element-70">
            Shopify
          </a>
          <a href="/wine" className="text-[#FAF7F2] hover:text-[#D4A574] transition-colors font-['Inter']" data-id="element-71">
            Wine
          </a>
          <a href="/about" className="text-[#FAF7F2] hover:text-[#D4A574] transition-colors font-['Inter']" data-id="element-72">
            About
          </a>
          <a href="/contact" className="text-[#FAF7F2] hover:text-[#D4A574] transition-colors font-['Inter']" data-id="element-73">
            Contact
          </a>
        </nav>
        {/* Social Links */}
        <div className="flex justify-center mb-8" data-id="element-74">
          <a href="https://www.linkedin.com/company/modern-commerce-io" target="_blank" rel="noopener noreferrer" className="text-[#FAF7F2] hover:text-[#D4A574] transition-colors" aria-label="LinkedIn" data-id="element-75">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" data-id="element-76">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-77" />
            </svg>
          </a>
        </div>

        {/* Copyright */}
        <div className="text-sm opacity-60 font-['Inter']" data-id="element-78">
          © 2026 Modern Commerce Architects. All rights reserved.
        </div>
      </div>
    </footer>;
}